// src/apiConfig.js
//const API_BASE_URL = "http://localhost:8080"; // change as needed
//const API_BASE_URL = "http://72.61.174.80:8080";
const API_BASE_URL = "https://cditbl.cloud:8443";
export default API_BASE_URL;

